import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useMemo
} from 'react';
import { withRouter } from 'react-router-dom';
import Tool_tabs from '../../Components/Tools/Tool_tabs';
import Header from '../../Components/Header/Header';
import { Global } from '../../App';
import { FormattedMessage } from 'react-intl';
import { CusButton } from '../../Components/From/Button';
import { CusInput } from '../../Components/From/Input';
import { AsyncModel, AsyncModelClose } from '../../Components/AsyncModel/AsyncModel';
import ReactLoading from 'react-loading';
import QrReader from 'react-qr-reader';
import moment from 'moment';
import {
  isIOS,
  isAndroid,
  isSafari,
  isChrome,
  isFirefox
} from 'react-device-detect';
import qs from 'querystring';
import cls from 'classnames';
import Tool_storeName from '../../Components/Tools/Tool_storeName';

// switch lang
import { langStringToCode } from '../../Share/Tools/switchLang';

// api
import { getOrderInfo } from '../../Api/staff/GetOrderInfo';
import { postCreateOrder } from '../../Api/GetOrder';
import {
  postManualVerifyQueue,
  postQRCodeVerifyQueue
} from '../../Api/VerifyQueue';

/**
 * @param {object} props
 *
 * 本次步驟會影響的global state
 * 1-1
 * currentCheckOrderStep => '2'
 * checkOrderBranch
 * checkOrderGroup
 * checkOrderStaff
 */

function StaffOrderStep_2(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    isLogin: false,
    isSearching: false,
    isShowBlock: true,
    useQRCode: false, // 是否使用QRCode掃描
    dataPicker: {
      selectTime: moment().format('YYYY/MM/DD')
    },
    dropDown: {
      toggle: false,
      selectItem: { value: 1 }
    },
    searchInput: '',
    orderList: []
  });

  const nextInput = useRef(null);
  function handleFocus() {
    nextInput.current.focus()
  }

  const clickBtn = useRef(null);
  function handleClick() {
    clickBtn.current.click()
  }

  // tabs的選項
  const verifyItems = [
    {
      title: <FormattedMessage id="pages.staffTakeOrder.step2.tabs.code" />,
      info: 'code',
      className: 'staff-order-step2-use-code'
    }, {
      title: <FormattedMessage id="pages.staffTakeOrder.step2.tabs.qr" />,
      info: 'qr',
      className: 'staff-order-step2-use-qr'
    }
  ];

  // 是否使用qrcode掃描過
  const isScan = useRef(true);

  // 驗證排隊號碼 & 取號驗證碼
  async function apiManualVerifyQueue(requireData) {
    const waittingAlert = AsyncModel({
      content: (
        <div className="w-100 d-flex justify-content-center">
          <ReactLoading
            type="spokes"
            color="#ccc"
            height="100px"
            width="100px"
          />
        </div>
      ),
      showConfirmBtn: false
    });
    try {
      const res = await postManualVerifyQueue(requireData);
      const { errCode } = res.data;
      AsyncModelClose();
      // 驗證通過
      if (res) {
        let {
          verify,
          childCount,
          adultsCount,
          countryID,
          countryName,
          storeID,
          storeName,
          orderCode,
          createAt
        } = res.data.response;
        if (orderCode !== null) {
          dispatchGlobal({
            type: 'UPDATE',
            payload: [
              {
                key: 'staffInfo',
                val: {
                  ...globalState.staffInfo,
                  orderCode
                }
              }
            ]
          });
          props.history.replace('/staffOrderDetail');
        } else {
          if (errCode === 200) {
            try {
              let res = await postCreateOrder({
                queueNumber: requireData.queueNumber,
                queueCode: requireData.queueCode,
                countryID: countryID,
                storeID: globalState.staffInfo.checkOrderBranch.branchCode,
                adultsCount: adultsCount,
                childCount: childCount,
                languageID: langStringToCode(globalState.langType),
                userEmail: '',
                dineIn: [],
                takeout: [],
                totalPrice: 0,
                waiterID: globalState.staffInfo.checkOrderStaff.staffCode,
                orderExtraList:[2]
              });
              const { orderCode } = res.data.order;
              const { errCode } = res.data;
              // AsyncModelClose();
              if (errCode === 200) {
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [
                    {
                      key: 'staffInfo',
                      val: {
                        ...globalState.staffInfo,
                        currentTakeOrderStep: '4',
                        orderCode,
                        takeOrderData: {
                          ...globalState.staffInfo.takeOrderData,
                          country: countryID,
                          countryName: countryName,
                          queueNumber: requireData.queueNumber,
                          queueCode: requireData.queueCode,
                          numberOfAdult: adultsCount,
                          numberOfChild: childCount
                        }
                      }
                    }
                  ]
                });
              } else {
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [{ key: 'errMsg', val: errCode }]
                });
                props.history.push('/staff/error');
              }
            } catch (err) {
              console.error('CreateOrder error.');
              dispatchGlobal({
                type: 'UPDATE',
                payload: [{ key: 'errMsg', val: 409 }]
              });
              props.history.push('/staff/error');
            }
          }
          else{
            dispatchGlobal({
              type: 'UPDATE',
              payload: [{ key: 'errMsg', val: 405 }]
            });
            props.history.push('/staff/error');
          }
        }
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: res.data.errCode }]
        });
        props.history.push('/staff/error');
      }
    } catch (err) {
      AsyncModelClose();
      console.error('LangOption error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 405 }]
      });
      props.history.push('/staff/error');
    }
  }
  // 驗證來店資訊
  async function apiVerifyQRCode(par) {
    try {
      const res = await postQRCodeVerifyQueue({
        queueNumber: par.queueNumber,
        queueCode: par.queueCode,
        storeID: par.storeID
      });
      const { errCode } = res.data;
      if (res && errCode == 200) {
        return res;
        // 已建單
      } else if (res && errCode == 420) {
        const { orderCode, storeID, createAt } = res.data.response;
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: 'staffInfo',
              val: {
                ...globalState.staffInfo,
                orderCode,
                createAt,
                checkOrderBranch: {
                  ...globalState.staffInfo.checkOrderBranch,
                  branchCode: storeID
                }
              }
            }
          ]
        });
        props.history.replace('/staffOrderDetail');
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/staff/error');
      }
    } catch (err) {
      console.error('QRCodeVerifyQueue error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 405 }]
      });
      props.history.push('/staff/error');
    }
  }

  async function apiOrderInfo(orderCode, storeID, createAt) {
    const langId = langStringToCode(globalState.langType)
    const waiterID = globalState.staffInfo.checkOrderStaff.staffCode
    try {
      const res = await getOrderInfo(orderCode, langId, waiterID, storeID, createAt);
      const { errCode, productList: orderInfo } = res.data;

      if (errCode === 200) {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: 'staffInfo.orderCode',
              val: orderCode
            }, {
              key: 'staffInfo.currentCheckOrderStep',
              val: '3'
            }, {
              key: 'staffInfo.prevPath',
              val: '/staffTakeOrder'
            }, {
              key: 'staffInfo.checkOrderData',
              val: {
                state: orderInfo.status,
                dineIn: orderInfo.dineIn,
                takeout: orderInfo.takeout,
                numberOfAdult: orderInfo.adultsCount,
                numberOfChild: orderInfo.childCount,
                country: {
                  countryId: orderInfo.countryID,
                  countryName: orderInfo.countryName
                },
                queueNumber: orderInfo.queueNumber,
                queueCode: orderInfo.queueCode,
                orderTime: orderInfo.createAt,
                branch: {
                  branchCode: orderInfo.storeID,
                  branchName: orderInfo.storeName
                },
                remark: orderInfo.remark
              }
            }
          ]
        });
      }
      else {
        console.error('OrderInfo error.');
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/staff/error');
      }
    } catch (err) {
      console.error('OrderInfo error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 413 }]
      });
      props.history.push('/staff/error');
    }
  }

  // 檢查是否有登入
  useEffect(() => {
    const handle = async () => {
      let {
        checkOrderBranch,
        checkOrderGroup,
        checkOrderStaff
      } = globalState.staffInfo;
      if (!checkOrderBranch || !checkOrderGroup || !checkOrderStaff) {
        // setState(curr => {
        //   let newState = { ...curr };
        //   newState.popup.toggle = true;
        //   return newState;
        // });
        const alert = await AsyncModel({
          title: globalState.langFile['popup.msgLoginWarning'],
          confirmBtnText: globalState.langFile['popup.buttonConfirm']
        });
        if (alert) {
          dispatchGlobal({ type: 'RESET' });
          props.history.replace('/staffCheckOrder');
        }
      } else {
        setState(curr => {
          let newState = { ...curr };
          newState.isLogin = true;
          return newState;
        });
      }
    };
    handle();
  }, []);
  useEffect(() => {
    if (globalState.staffInfo.orderCode) {
      props.history.replace('/staffOrderDetail');
    }
  }, [globalState.staffInfo.orderCode]);

  // QRcode掃描
  const showQRCode = useMemo(() => {
    if (
      !state.useQRCode || // 沒有選擇QRCode功能
      // globalState.device === 'pc' || // 非行動裝置
      (isIOS && !isSafari) || // ios系統但瀏覽器非safari
      (isAndroid && !(isChrome || isFirefox)) // android系統但瀏覽器非 chrome || firefox
    )
      return null;
    return (
      <div className="Pages__QRCode">
        <QrReader
          delay={600}
          onError={err => {
            console.error(err);
          }}
          onScan={async data => {
            let par; //是否有合法的參數
            if (!data) return (isScan.current = true);
            if (data && isScan.current) {
              par = qs.parse(data.split('?')[1]);
              isScan.current = false;
              const waittingAlert = AsyncModel({
                content: (
                  <div className="w-100 d-flex justify-content-center">
                    <ReactLoading
                      type="spokes"
                      color="#ccc"
                      height="100px"
                      width="100px"
                    />
                  </div>
                ),
                showConfirmBtn: false
              });
            }
            const isCheckOrder = data.indexOf('staffCheckOrder') > -1,
              isTakeOrder = data.indexOf('QRCodeSuccess') > -1;
            if (par && isCheckOrder) {
              AsyncModelClose();
              apiOrderInfo(par.orderCode, par.storeID, par.createAt);
            } else if (par && isTakeOrder) {
              // AsyncModelClose();
              const qrcode = await apiVerifyQRCode(par);
              if (qrcode) {
                apiManualVerifyQueue({
                  queueNumber: par.queueNumber,
                  queueCode: par.queueCode,
                  storeID: qrcode.data.response.storeID,
                  languageID: langStringToCode(globalState.langType)
                });
              } else {
                AsyncModelClose();
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [{ key: 'errMsg', val: 419 }]
                });
                props.history.push('/staff/error');
              }
            } else {
              AsyncModelClose();
              dispatchGlobal({
                type: 'UPDATE',
                payload: [{ key: 'errMsg', val: 419 }]
              });
              props.history.push('/staff/error');
            }
          }}
          style={{ width: '100%' }}
        />
      </div>
    );
  }, [state.useQRCode, globalState.device]);
  // 輸入排隊號碼 & 取號驗證碼
  const showInputFrom = useMemo(() => {
    console.log('globalState', globalState)
    console.log('state', state)
    let pcStyle = globalState.device === 'pc';
    if (
      state.useQRCode // QRcode 模式開啟時 => 隱藏
    )
      return null;
    return (
      <div className="d-flex col flex-column justify-content-center align-items-center p-0">
        <div style={{ minWidth: pcStyle ? '500px' : '100%' }}>
          {/* 排隊號碼 */}
          <div className="mb-4 mb-sm-5 w-100">
            <FormattedMessage
              type="tel"
              id="pages.staffTakeOrder.step2.queueNumberInputPlaceholder"
              children={msg => {
                return (
                  <CusInput
                    type="tel"
                    className={cls('w-100')}
                    maxLength={4}
                    label={
                      <FormattedMessage id="pages.staffTakeOrder.step2.queueNumberInputTitle" />
                    }
                    value={state.queueNumber}
                    onKeyPress={(ev) => {
                      if (ev.key === 'Enter') {
                        handleFocus()
                      }
                    }}
                    placeholder={msg}
                    onChange={event => {
                      let val = event.target.value;
                      setState(curr => {
                        let newState = { ...curr };
                        newState.queueNumber = val;
                        return newState;
                      });
                    }}
                  />
                );
              }}
            />
          </div>
          {/* 取號驗證碼 */}
          <div className="mb-4 mb-sm-5 w-100">
            <FormattedMessage
              id="pages.staffTakeOrder.step2.queueCodeInputPlaceholder"
              children={msg => {
                return (
                  <CusInput
                    type="tel"
                    // pattern="[0-9]*"
                    className={cls('w-100')}
                    maxLength={5}
                    label={
                      <FormattedMessage id="pages.staffTakeOrder.step2.queueCodeInputTitle" />
                    }
                    innerRef={nextInput}
                    value={state.queueCode}
                    placeholder={msg}
                    onKeyPress={(ev) => {
                      if (ev.key === 'Enter') {
                        handleClick()
                      }
                    }}
                    onChange={event => {
                      let val = event.target.value;
                      setState(curr => {
                        let newState = { ...curr };
                        newState.queueCode = val;
                        return newState;
                      });
                    }}
                  />
                );
              }}
            />
          </div>
          {/* button */}
          <div className="d-flex flex-column justify-content-center align-items-center mt-3">
            <CusButton.White
              className="col p-3 staff-order-step1-skip"
              children={
                <FormattedMessage id="pages.staffTakeOrder.buttonSkip" />
              }
              onClick={() => {
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [
                    {
                      key: 'staffInfo',
                      val: {
                        ...globalState.staffInfo,
                        currentTakeOrderStep: '3',
                      }
                    }
                  ]
                });
              }}
            />
          </div>
          <div className="mt-1 mb-3 mt-sm-1 mb-sm-5 w-100 d-flex">
            <CusButton.White
              className="mt-2 mb-2 mr-3 col p-3 staff-order-step1-back"
              children={
                <FormattedMessage id="pages.staffTakeOrder.step2.buttonBack" />
              }
              onClick={() => {
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [
                    {
                      key: 'staffInfo',
                      val: {
                        ...globalState.staffInfo,
                        currentTakeOrderStep: '1',
                        checkOrderStaff: ''
                      }
                    }
                  ]
                });
              }}
            />
            <CusButton.Red
              className="mt-2 mb-2 ml-3 col p-3 staff-order-step1-confirm"
              disabled={!state.queueNumber || !state.queueCode}
              children={
                <FormattedMessage id="pages.staffTakeOrder.step2.buttonConfirm" />
              }
              innerRef={clickBtn}
              onClick={async () => {
                let {
                  branchCode
                } = globalState.staffInfo.checkOrderBranch;
                apiManualVerifyQueue({
                  queueNumber: state.queueNumber,
                  queueCode: state.queueCode,
                  storeID: branchCode,
                  languageID: langStringToCode(globalState.langType)
                });
              }}
            />
          </div>
        </div>
      </div>
    );
  }, [
    globalState.customer.orderInfo.selectedBranch,
    globalState.device,
    state.useQRCode,
    state.queueNumber,
    state.queueCode
  ]);
  if (!state.isLogin) return null;
  return (
    <>
      <Header />
      <div className="d-flex align-items-center justify-content-center txtColorBrown mb-3">
        <span className="m-2">
          <Tool_storeName storeId={globalState.staffInfo.checkOrderBranch.branchCode} />
          {/* {globalState.staffInfo.checkOrderBranch.branchName} */}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderGroup.groupName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffNum}
        </span>
      </div>
      <div className="Pages__section d-flex flex-column col p-0">
        {/* 選擇驗證方式 tabs */}
        {(() => {
          // 禁止顯示 tabs
          if (
            // globalState.device === 'pc' || // 非行動裝置   // 消費者先不判斷寬度
            (isIOS && !isSafari) || // ios系統但瀏覽器非safari
            (isAndroid && !(isChrome || isFirefox)) // android系統但瀏覽器非 chrome || firefox
          )
            return null;
          return (
            <Tool_tabs
              items={verifyItems}
              selected={state.selectedTab || verifyItems[0]}
              onChangeItems={selectedTab => {
                let useQRCode = selectedTab.info === 'qr';
                setState(curr => {
                  let newState = { ...curr };
                  newState.selectedTab = selectedTab;
                  newState.useQRCode = useQRCode;
                  return newState;
                });
              }}
            />
          );
        })()}
        <div className="d-flex col flex-column mt-3 mb-3 p-0">
          <>
            {showQRCode}
            {showInputFrom}
          </>
        </div>
      </div>
    </>
  );
}

export default withRouter(StaffOrderStep_2);